"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainHander = void 0;
var mainHandler_1 = require("./mainHandler");
Object.defineProperty(exports, "mainHander", { enumerable: true, get: function () { return mainHandler_1.default; } });
